import { memo, useEffect } from "react";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import AOS from "aos";
import "aos/dist/aos.css";
import "./style.scss";
import banner1Img from "assets/users/images/homepage/prop_1.png";
import banner2Img from "assets/users/images/homepage/prop_2.png";
import banner3Img from "assets/users/images/homepage/prop_3.png";
import banner4Img from "assets/users/images/homepage/prop_4.png";
import cate1Img from "assets/users/images/categories/cate_1.png";
import cate2Img from "assets/users/images/categories/cate_2.png";
import cate3Img from "assets/users/images/categories/cate_3.png";
import cate4Img from "assets/users/images/categories/cate_4.png";
import cate5Img from "assets/users/images/categories/cate_5.png";

const HomePage = () => {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 4
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    useEffect(() => {
        AOS.init({
            duration: 600,
            easing: "ease-out",
            once: false, // Để false để chạy lại khi cuộn
        });

        const handleScroll = () => {
            AOS.refresh(); // Reset AOS mỗi khi cuộn
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            {/*Categories Begin */}
            <div className="container container__categories_slider">
                <div className="section-title">

                    <h2>Some Feedback</h2>
                </div>
                <Carousel responsive={responsive} className="categories_slider">
                    <div className="categories_slider_item" style={{ backgroundImage: `url(${cate5Img})` }}></div>
                    <div className="categories_slider_item" style={{ backgroundImage: `url(${cate2Img})` }}></div>
                    <div className="categories_slider_item" style={{ backgroundImage: `url(${cate3Img})` }}></div>
                    <div className="categories_slider_item" style={{ backgroundImage: `url(${cate4Img})` }}></div>
                    <div className="categories_slider_item" style={{ backgroundImage: `url(${cate1Img})` }}></div>
                </Carousel>

            </div>
            {/*Categories End */}

            <div className="container">
                <div className="banner">
                    <div data-aos="fade-up" data-aos-delay="100" className="banner__pic">
                        <img src={banner1Img} alt="banner" />
                    </div>
                    <div data-aos="fade-up" data-aos-delay="100" className="banner__text">
                        <h2> Create a Memory Capsule </h2>
                        <div className="banner__description">
                            <p>Users can create a "Time Capsule" containing messages, images, videos, audio, or important documents.</p>
                        </div>
                    </div>
                </div>
                <div className="banner">
                    <div data-aos="fade-up" data-aos-delay="100" className="banner__text">
                        <h2> Schedule Capsule Opening </h2>
                        <div className="banner__description">
                            <p>Set an exact date and time to open it in the future (months or even years later).</p>
                        </div>
                    </div>
                    <div data-aos="fade-up" data-aos-delay="100" className="banner__pic">
                        <img src={banner2Img} alt="banner" />
                    </div>
                </div>
                <div className="banner">
                    <div data-aos="fade-up" data-aos-delay="100" className="banner__pic">
                        <img src={banner3Img} alt="banner" />
                    </div>
                    <div data-aos="fade-up" data-aos-delay="100" className="banner__text">
                        <h2> Send to Loved Ones & Friends </h2>
                        <div className="banner__description">
                            <p>Users can send their Time Capsule to themselves or important people in their lives.</p>
                        </div>
                    </div>
                </div>
                <div className="banner">
                    <div data-aos="fade-up" data-aos-delay="100" className="banner__text">
                        <h2> Data Security & Encryption </h2>
                        <div className="banner__description">
                            <p>All data is encrypted to ensure safety and privacy.</p>
                        </div>
                    </div>
                    <div data-aos="fade-up" data-aos-delay="100" className="banner__pic">
                        <img src={banner4Img} alt="banner" />
                    </div>
                </div>
            </div>
            {/*Banner End */}
        </>
    );
};

export default memo(HomePage);